
function SdInputDropdownCtrl(TranslationService, StoreService) {
    var ctrl = this;

    ctrl.translation = TranslationService.getActiveTranslation();


    ctrl.$onInit = function () {
        ctrl.loaded = false;

    };

    ctrl.selectOption = function (option, event) {
        //ctrl.ngModel = option.Key;
        //ctrl.value = option.Value;

        ctrl.ngModel = option;
        ctrl.value = option;


        //ctrl.mode = option.ContactName;
        //ctrl.contact = option;
    };

    ctrl.getValue = function () {
        if (ctrl.ngModel && ctrl.options) {
            var item = ctrl.options.find(function (p) {
                return p == ctrl.ngModel;
                //return p.Key == ctrl.ngModel;
            });
            if (item) {
                //return item.Value;
                return item;
            }
        }
        return '';
    };
}

SdInputDropdownCtrl.$inject = ['TranslationService', 'StoreService'];

seedWebApp.component('sdInputDropdown', {
    controller: SdInputDropdownCtrl,
    bindings: {
        ngModel: '=',
        Name: '=',
        label: '<',
        options: '=',
        disabled: '<',
        keyField: '<',
        valueField: '<',
    },
    templateUrl: '/SPA/Components/sd-input-dropdown.html'
});